<template>
  <form class="sneos-contact" @submit.prevent="submitMessage">
    <input type="text" placeholder="Your name" v-model="name" />
    <input type="email" placeholder="Your email address" v-model="email" />
    <textarea placeholder="Your message" v-model="message" />
    <button type="submit" v-on:click="$emit('submitted-contact-form')">
      Submit
    </button>
    <label for="modal_c" class="pseudo button">&times; Close</label>
  </form>
</template>

<script>
import firebase from "../../firebaseConfig";
const db = firebase.firestore();

export default {
  name: "ContactForm",
  data: function () {
    return {
      name: "",
      email: "",
      message: "",
      client_key: "nVvPVAVVlaFhi6wzBFH8",
    };
  },
  methods: {
    submitMessage: function () {
      let clientId = db.doc("clients/" + this.client_key);

      console.log(this.name + " - " + this.email + "_" + this.message);

      db.collection("contactButton")
        .add({
          Message: this.message,
          Name: this.name,
          Email: this.email,
          ClientId: clientId,
        })
        .then(() => {
          console.log("Document successfully written!");
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    },
  },
};
</script>

<style scoped>
.sneos-contact input {
  padding: 1.3em 0.6em;
}
</style>